import { useFormContext } from "react-hook-form";
import { Autocomplete } from "src/components/shared/MantineCombobox";
import { INMEAMapItem } from "src/interfaces/NMEA";
import { StyledTd, StyledTr } from "src/styled";

interface Props extends INMEAMapItem {
  availableMappings: string[];
  index: number;
  watch: (name: string) => any;
  lbid: string | null;
}
const NMEAMappingItem = ({
  colName,
  availableMappings = [],
  lbid,
  index,
  watch,
}: Props) => {
  const { setValue } = useFormContext();
  const id = `list.${lbid}.${index}.mapsTo`;

  const handleChange = (value: string | null) => {
    setValue(id, value);
  };
  const value = watch(id);
  return (
    <StyledTr>
      <StyledTd>{colName}</StyledTd>
      <StyledTd>
        <Autocomplete
          data={availableMappings}
          value={value ?? ""}
          onChange={handleChange}
        />
      </StyledTd>
    </StyledTr>
  );
};
export default NMEAMappingItem;
